/**
 * FormFlow Web Application Entry Point
 *
 * HIPAA COMPLIANCE NOTES:
 * - No PHI should be stored in browser storage (localStorage, sessionStorage)
 * - All form data must be transmitted securely via API
 * - Analytics must exclude PHI (no form values, no query strings)
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
